// FILE: src/lib/authDebug.js  (NEW)
import { signInWithEmailAndPassword } from "firebase/auth";

/**
 * Wraps signInWithEmailAndPassword to surface the exact Identity Toolkit error.
 * Success path unchanged. On failure: logs + small alert, then rethrows for your UI.
 */
export async function signInWithEmailAndPasswordDebug(auth, email, password) {
  try {
    const cred = await signInWithEmailAndPassword(auth, email, password);
    return cred;
  } catch (e) {
    const code = e?.code || "";                    // e.g. auth/invalid-api-key, auth/operation-not-allowed
    const restMsg = e?.customData?.message || "";  // raw REST message when present
    // eslint-disable-next-line no-console
    console.error("[LOGIN ERROR]", { code, restMsg, raw: e });
    alert(`Login failed: ${code}${restMsg ? " - " + restMsg : ""}`);
    throw e;
  }
}
